<kl-form-container
  [title]="title + (mode === 'edit' || mode === 'view' ? entity.code : '')"
  [mode]="mode"
  [pageId]="tabId ? tabId : modalId"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow || errorShow"
  [alertType]="alertType"
  (onCloseAlert)="alertShow = false; errorShow = false"
  (onCommitSave)="commitSave($event)"
>
  <form #UserRoleForm="ngForm" novalidate>
    <accordion>
      <accordion-group
        [isOpen]="isOpenFirstAccordion"
        (isOpenChange)="isOpenFirstAccordion = $event"
      >
        <div accordion-heading class="clearfix">
          {{ "general_information" | translate }}
          <span class="badge badge-secondary float-right pull-right"
            ><i
              class="fa"
              [ngClass]="isOpenFirstAccordion ? 'fa-minus' : 'fa-plus'"
            ></i
          ></span>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-6">
              <div class="form-group row">
                <label for="role_type" class="col-3">
                  <small>{{ "type" | translate }}</small>
                </label>
                <div class="col-9">
                  <p-dropdown
                    [emptyFilterMessage]="'not_found' | translate"
                    [disabled]="isReadOnly"
                    [options]="[
                      {
                        label: 'ROLE_SUPERVISOR' | translate,
                        value: 'ROLE_SUPERVISOR'
                      },
                      { label: 'ROLE_USER' | translate, value: 'ROLE_USER' },
                      { label: 'ROLE_GUEST' | translate, value: 'ROLE_GUEST' }
                    ]"
                    [(ngModel)]="entity.type"
                    (onChange)="formChange(true)"
                    name="role_type"
                    id="role_type"
                    [style]="{ width: '100%' }"
                  >
                  </p-dropdown>
                </div>
              </div>
              <div class="form-group row">
                <label for="role_code" class="col-3">
                  <small>
                    {{ "number" | translate }}
                    <i class="text-danger">*</i></small
                  >
                </label>
                <div class="col-md-9 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      [disabled]="isReadOnly"
                      id="role_code"
                      name="role_code"
                      class="form-control form-control-sm"
                      required
                      maxlength="10"
                      #role_code="ngModel"
                      [ngClass]="
                        errorShow && role_code.invalid ? 'errorInput' : ''
                      "
                      (ngModelChange)="formChange(true)"
                      [(ngModel)]="entity.code"
                    />
                    <div
                      class="input-group-append"
                      (click)="isReadOnly ? '' : generateCode()"
                    >
                      <span
                        class="input-group-text transparent code-icon"
                        id="basic-addon2"
                      >
                        <img src="assets/img/keys.svg" style="width: 20px" />
                      </span>
                    </div>
                    <div
                      *ngIf="errorShow && role_code.invalid"
                      class="errorMessage"
                    >
                      {{ "important_area" | translate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="role_description" class="col-3">
                  <small
                    >{{ "description" | translate }}
                    <i class="text-danger">*</i></small
                  >
                </label>
                <div class="col-9">
                  <input
                    type="text"
                    maxlength="50"
                    name="role_description"
                    id="role_description"
                    #role_description="ngModel"
                    #focusElement
                    [disabled]="isReadOnly"
                    (ngModelChange)="formChange(true)"
                    [(ngModel)]="entity.description"
                    [ngClass]="
                      errorShow && role_description.invalid ? 'errorInput' : ''
                    "
                    class="form-control form-control-sm"
                    aria-describedby="role_description_help_text"
                    required
                  />
                  <div
                    *ngIf="errorShow && role_description.invalid"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </accordion-group>
    </accordion>
  </form>
</kl-form-container>
